/**
 * The reference's own words (T13c): what each group of routes is for, and the hub's five ways in. Everything
 * else on the reference pages is read from the contract and the SDKs' source. A test holds GROUP_SAYS to the
 * contract's groups, so a group the contract gains or drops fails until this says what it is.
 */
export const GROUP_SAYS: Readonly<Record<string, string>> = {
  Account:
    "Your company's account: who is calling, its keys, its caps, what it spent and the models it may use.",
  Users:
    "Your users: set one up, read their spend, change their cap, export or erase them.",
  Conversations:
    "Ask Bash in a conversation, follow its reply as it happens, and stop it.",
  Work: "The work Bash does on its computer: list it, read it, stop it or delete it.",
  Interactions:
    "What Bash waits on (approvals, questions, apps to connect, hand-offs, calls to your tools) and the answers.",
  Files: "Files Bash makes, and files you hand it.",
  "Connected apps":
    "The apps each user connects through a sign-in link, and the apps they may choose from.",
  "MCP servers and secrets":
    "Your MCP servers and the tools they offer, and the secrets Bash uses but never shows.",
  Skills:
    "Skills your Bash may use: upload one, give it new versions, list them.",
  Notebooks:
    "Knowledge Bash reads before it answers: notebooks, and the documents in them.",
  Memory:
    "What Bash remembers about each user: read it, search it, add to it, forget it.",
  Deployments:
    "How your Bash is set up, in versions: apply a whole vestra.yaml, promote, roll back, and the interview that drafts the file.",
  Tests:
    "The scenarios a version must pass, drafted or written, and the runs that check it before your users see it.",
  "Computer setup": "Wake a user's computer before they need it.",
  Routines:
    "Jobs Bash runs on a schedule in plain words, or whenever your system calls.",
  Batches: "Many users at once: one ask each, followed together.",
  "Webhooks and events":
    "Where events go, how each delivery went, and the record of every event.",
  Sessions:
    "Bash in a browser: its live screen, a voice call, or the whole of Bash inside your app.",
  "MCP server": "Bash as an MCP server, for your editor or your own agents.",
  A2A: "Each deployment as an agent other agents can call, over the A2A protocol.",
  Contract: "The contract itself, as OpenAPI.",
};

/** The hub's five, each with where it goes and what a developer looks up there. */
export const REFERENCES: ReadonlyArray<{
  id: string;
  title: string;
  href: string;
  says: string;
}> = [
  {
    id: "api",
    title: "API",
    href: "/developers/reference/api",
    says: "Every route: what it does, every field it takes and answers, and a sample in your language.",
  },
  {
    id: "file",
    title: "vestra.yaml",
    href: "/developers/reference/file",
    says: "Every field of the file that sets up your Bash: what it does, its type and default, and an example.",
  },
  {
    id: "events",
    title: "Events",
    href: "/developers/reference/events",
    says: "Every event on the stream and in your webhooks, and every field it carries.",
  },
  {
    id: "errors",
    title: "Errors",
    href: "/developers/reference/errors",
    says: "Every error code the API answers: its status, what it means, and what to do.",
  },
  {
    id: "sdk",
    title: "SDKs and CLI",
    href: "/developers/reference/sdk",
    says: "Every method of the TypeScript and Python SDKs, and every command of the CLI.",
  },
];
